import React, { useState, useEffect } from "react";
import { selectedHorseStore } from "store/selectedHorse";
import Alert from "components/alert";
import ReactGA from "react-ga4";
import axios from "axios";

const buttonBgColors = {
  "none": "bg-white",
  "yellow": "bg-yellow-400",
  "green": "bg-green-700",
}

const gradinetStyle = {
  indigo: " from-indigo-800",
  green: " from-green-700",
  "hawkstonian-gold": " from-[#b2a78f]",
  none: "",
};

const backgroundColor = {
  none: "",
  indigo: " bg-indigo-800",
  green: " bg-green-700",
  'hawkstonian-gold': ' bg-[#b2a78f]',
};

const messageVariants = {
  waiting_list: "Joined Successfuly!",
  reservation: "Shares Reserved Successfuly!",
  "general-waiting-list": "Successfuly Added!",
  "racing-weekly": "Successfuly Added!",
};

const listTypes = {
  waiting_list: "Waiting List",
  reservation: "Reservation List",
  "general-waiting-list": "Waiting List",
  "racing-weekly": "Racing Weekly",
};

// TODO: make the component more readable are changable
const Newsletter = ({ data }) => {

  let normalText = undefined;
  let submitingText = undefined;
  let submittedText = undefined;
  let title = undefined;

  if (data) {
    normalText = data.buttonText?.normalText || data.newsletter?.buttonText?.normalText
    submitingText = data.buttonText?.submitingText || data.newsletter?.buttonText?.submitingText
    submittedText = data.buttonText?.submittedText || data.newsletter?.buttonText?.submittedText
    title = data.title || data.newsletter?.title
  }

  const { 
    insideContainer,
    moduleflow,
    overlayColor,
    image,
    // title,
    inputs,
    newsletterType,
    subscribeUserType,
    waitingListType,
    inputStructure,
    buttonBgColor,
    // buttonText,
   } = !data?.isReference ? data : data?.newsletter;

  const { selectedHorse } = selectedHorseStore();
  const [info, setInfo] = useState({});
  const [img, setImage] = useState(image);
  const [submitting, setSubmitting] = useState(false);
  const [messageStatus, setMessage] = useState({
    message: "",
    success: true,
  });

  useEffect(() => {
    emptyValues();

    if (data.image) setImage(data.image);
  }, []);

  const changeValue = (target, value) => {
    setInfo({ ...info, [target]: value });
  };

  const emptyValues = () => {
    setInfo(inputs?.reduce((info, { id }) => ({ ...info, [id]: "" }), {}));
  };

  const sendData = async (e) => {
    e.preventDefault();

    let { first_name, last_name, full_name, email, phone } = info;

    if (full_name) {
      first_name = full_name.split(" ")[0];
      last_name = full_name.split(" ")[1];
    }

    let url = `https://shop.oldgoldracing.com/`;

    // Mailchimp motifications
    if (waitingListType) {
      phone = phone ? `${phone}` : "000000";
      url += `${newsletterType}/${waitingListType}/${selectedHorse?.slug}/${first_name}/${last_name}/${email}/${phone}`;
    }

    if (subscribeUserType)
      url += `${newsletterType}/${subscribeUserType}/${email}/${first_name}/${last_name}`;

    setSubmitting(true);

    ReactGA.event({
      category: "Newsletter",
      action: "submitted_newsletter_form",
      label: waitingListType || subscribeUserType,
    });

    //Mailchimp api
    try {
      const res = await axios.get(url);
      setSubmitting(false);
      emptyValues();
      setMessage({
        message: submittedText ? submittedText : messageVariants[waitingListType || subscribeUserType],
        success: true,
      });
    } catch (e) {
      console.log(e);
      setSubmitting(false);
      setMessage({
        message: "Something Went Wrong, contact OGR!",
        success: false,
      });
    }

    //klaviyo api
    const options = {
      method: "POST",
      headers: {
        Accept: "*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        list_type: listTypes[waitingListType || subscribeUserType],
        first_name,
        last_name,
        email,
        phone: phone || null,
        slug: selectedHorse?.slug || null,
      }),
    };

    try {
      const response = await fetch(`https://shop.oldgoldracing.com/joinList`, options)
      if (!response.ok) {
        let errorData = '';

        if (response.status == 409) {
          errorData = await response.json();
        }

        throw new Error(errorData.error || "Something Went Wrong, contact OGR!");
      }
    } catch (error) {
      console.error('Error:', error.message);
      setMessage({
        message: error.message,
        success: false,
      });
    }
  };

  return (
    <div
      className={`${insideContainer ? "container sm:!px-0" : ""} scroll-m-20`}
      id={waitingListType && "waiting_list"}
    >
      <div
        className={`relative ${insideContainer ? "flex " : ""} ${
          moduleflow == "left"
            ? "flex-row sm:flex-col"
            : "flex-row-reverse sm:flex-col-reverse"
        } ${backgroundColor[overlayColor]}`}
      >
        {img && (
          <div
            className={`${
              insideContainer
                ? "relative w-full"
                : `w-full h-full absolute top-0 left-0 flex sm:relative sm:-mb-16 sm:h-26 ${
                    moduleflow == "left" ? "justify-start" : "justify-end"
                  }`
            }`}
          >
            <div
              className={`relative flex sm:w-full overflow-hidden ${
                insideContainer
                  ? "w-full h-full"
                  : moduleflow == "left"
                  ? "w-1/2"
                  : "w-7/12"
              }`}
            >
              <div
                className={`w-full h-full absolute top-0 left-0 z-[2] sm:bg-gradient-to-t ${
                  moduleflow == "left" ? "bg-gradient-to-l" : "bg-gradient-to-r"
                }${gradinetStyle[overlayColor]}`}
              />

              <img
                src={img?.src}
                alt={img?.alt}
                className={`w-full max-h-[700px] object-cover ${
                  insideContainer ? "max-h-fit" : ""
                }`}
              />
            </div>
          </div>
        )}

        <div
          className={` relative z-[3] sm:pt-0 ${
            insideContainer
              ? "py-20 px-14 sm:px-9 w-full flex items-center justify-start"
              : `container py-24 sm:pb-12`
          }`}
        >
          <div
            className={`max-w-xl sm:mx-auto ${
              moduleflow == "left" && insideContainer
                ? "mr-0 ml-auto lg:max-w-[50%] md:max-w-[50%]"
                : ""
            }`}
          >
            <h2 className="header leading-snug !text-white">{title}</h2>

            <form
              onSubmit={sendData}
              className={`mt-12 gap-6 w-full sm:w-full ${
                inputStructure == "flex"
                  ? "flex flex-col"
                  : "grid grid-cols-2 sm:grid-cols-1"
              }`}
            >
              {inputs?.map(({ name, placeholder, icon, id, type }, index) => (
                <div className="relative w-full" key={index}>
                  <input
                    type={type}
                    value={info[id]}
                    onChange={({ target: { value } }) => changeValue(id, value)}
                    className="w-full border border-solid border-gray-300 py-4 pl-11 pr-3 bg-transparent outline-none text-white rounded-md"
                    placeholder={placeholder}
                    required
                  />
                  <img
                    src={icon.src}
                    alt={icon.alt}
                    className="!absolute left-3 bottom-1/2 translate-y-1/2 w-6 h-6"
                  />
                </div>
              ))}
              <button
                type="submit"
                className={`py-3 paragraph-lg-bold text-gray-100 ${buttonBgColor ? buttonBgColors[buttonBgColor] : "bg-yellow-400"} rounded ${
                  inputs?.length == 4 ? "col-span-2 sm:col-span-1" : ""
                }`}
              >
                {submitting ? submitingText : normalText}
              </button>
            </form>
            <div></div>
            {messageStatus.message && (
              <Alert
                success={messageStatus.success}
                message={messageStatus.message}
                onClose={() => setMessage({ message: "" })}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
